import VueRouter from 'vue-router';
import createRoutes from './routes';

export default store => {
  const router = new VueRouter({
    mode: 'history',
    base: '/',
    routes: createRoutes(store),
  });

  router.beforeEach((to, from, next) => {
    if (store.getters.isLoggedIn) {
      store.getters.ping();
    }
    next();
  });

  router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.auth)) {
      if (!store.getters.isLoggedIn) {
        next({ name: 'login', query: { redirect: to.fullPath } });
      } else {
        next();
      }
    } else if (to.matched.some(record => record.meta.hasOwnProperty('auth') && record.meta.auth === false)) {
      if (store.getters.isLoggedIn) {
        next({ name: 'home' });
      } else {
        next();
      }
    } else {
      next();
    }
  });

  router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.admin)) {
      if (!store.getters.isAdmin) {
        next({ name: 'home' });
      } else {
        next();
      }
    } else {
      next();
    }
  });

  router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.comarkAdmin)) {
      if (!store.getters.isComarkAdmin) {
        next({ name: 'home' });
      } else {
        next();
      }
    } else {
      next();
    }
  });

  return router;
};
